import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import CompanyData from '@/components/Modals/MyCompany/CompanyData';
import EditCompanyData from '@/components/Modals/MyCompany/EditCompanyData';
import MainContainer from '@/layouts/MainContainer';
import { ArrowBack } from '@mui/icons-material';
import { Box, IconButton, Modal, Typography } from '@mui/material';

interface IMyCompanyProps {
  isOpen: boolean;
  handleClose: () => void;
}

enum MyCompanyComponents {
  COMPANY_DATA,
  EDIT_COMPANY_DATA,
}

const MyCompany = ({ isOpen, handleClose }: IMyCompanyProps) => {
  const { query } = useRouter();
  const { edit_company } = query;

  const [currentComponent, setCurrentComponent] = useState(
    MyCompanyComponents.COMPANY_DATA
  );

  const returnToFirstStep = () =>
    setCurrentComponent(MyCompanyComponents.COMPANY_DATA);

  const handleClickBackIcon = () => {
    if (currentComponent === MyCompanyComponents.COMPANY_DATA) {
      handleClose();
      return;
    }
    returnToFirstStep();
  };

  const nextStep = () => {
    if (currentComponent !== MyCompanyComponents.EDIT_COMPANY_DATA) {
      setCurrentComponent(prevState => prevState + 1);
    }
  };

  useEffect(() => {
    if (edit_company === 'true') {
      setCurrentComponent(MyCompanyComponents.EDIT_COMPANY_DATA);
    }
  }, [edit_company]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-my-company"
      aria-describedby="modal-my-company-description"
      sx={{ overflowY: 'auto' }}
    >
      <>
        <Box
          sx={{
            boxShadow: '0px 1px 1px 0px #0000001A',
            backgroundColor: 'background.paper',
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px 16px',
            position: 'relative',
            zIndex: 999,
          }}
        >
          <IconButton
            onClick={handleClickBackIcon}
            sx={{ color: '#000000', position: 'absolute', left: '16px' }}
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" component="h2">
            Minha empresa
          </Typography>
        </Box>
        <Box sx={{ backgroundColor: 'background.default' }}>
          <MainContainer
            sx={{
              paddingY: '24px',
              display: 'flex',
              gap: '16px',
              flexDirection: 'column',
              minHeight: 'calc(100vh - 68px)',
            }}
          >
            {
              {
                [MyCompanyComponents.COMPANY_DATA]: (
                  <CompanyData nextStep={nextStep} />
                ),
                [MyCompanyComponents.EDIT_COMPANY_DATA]: (
                  <EditCompanyData
                    returnToModalHome={returnToFirstStep}
                    onClose={handleClose}
                  />
                ),
              }[currentComponent]
            }
          </MainContainer>
        </Box>
      </>
    </Modal>
  );
};

export default MyCompany;
export type { IMyCompanyProps };
export { MyCompanyComponents };
